import React from 'react';
import classnames from 'classnames';
import { BiDataHook } from '@wix/da-bi/pkg/constants';
import TextRenderer from '../TextRenderer';
import CommentViewer from '../DaEditorWrapper/Viewer/Comment';
import SpamView from '../Comment/commonSkeletonViews/SpamView';
import CommentSkeleton from '../Comment/lego/CommentSkeleton';
import HiddenView from '../Comment/commonSkeletonViews/HiddenView';
import CommentCoreBadgeList from '../coreBadge/CoreBadgeList/presets/CommentCoreBadgeList';
import s from './CommentBody.scss';
/** @deprecated */
var CommentBody = function (_a) {
    var comment = _a.comment, className = _a.className, bodyClassName = _a.bodyClassName;
    var textContent = comment.textContent, commentId = comment.commentId;
    return (React.createElement(CommentSkeleton, { className: className, comment: comment, editingView: null, spamView: React.createElement(SpamView, null), hiddenView: React.createElement(HiddenView, null), readView: React.createElement(React.Fragment, null,
            !!textContent && (React.createElement("div", { className: s['comment-body-wrap'], "data-hook": BiDataHook.COMMENT_BODY },
                React.createElement(TextRenderer, { textContent: textContent, reactViewer: CommentViewer, className: classnames(s['comment'], bodyClassName), legacyTheme: 'comments', viewerKey: commentId }))),
            comment.awardedBadges && React.createElement(CommentCoreBadgeList, { comment: comment })) }));
};
CommentBody.displayName = 'CommentBody';
export default CommentBody;
//# sourceMappingURL=CommentBody.js.map